import { BiteAttempt, BiteData } from "../../types/data";
import { formatDate } from "../../service/stats";
import { getBiteStyle } from "../../types/utils";
import { useSupportModalStore } from "../../stores/supportModalStore";
import { useTranscriptionsEnabled } from "@/hooks/useRuntimeFlags";

const formatTimeSpent = (ms: number): string => {
  const totalSeconds = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}m ${seconds}s`;
};

const getOrdinal = (n: number): string => {
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

const BiteCard = ({
  bite,
  attempt,
  index,
  studentName,
  lessonName,
  biteIndex,
  isBest = false,
}: {
  bite: BiteData;
  attempt: BiteAttempt;
  index: number;
  studentName: string;
  lessonName: string;
  biteIndex: number;
  isBest?: boolean;
}) => {
  const transcriptionsEnabled = useTranscriptionsEnabled();
  const { openModal } = useSupportModalStore();

  const { backgroundColor, border } = getBiteStyle(bite, attempt);

  const handleViewTranscripts = () => {
    openModal({
      studentName,
      lessonName,
      biteIndex,
      attempt,
      biteType: bite.biteType,
    });
  };

  return (
    <div
      className="flex flex-col gap-[10px] rounded-[10px] px-[15px] py-[10px] bg-white"
      style={{ boxShadow: "0 0 5px rgba(12, 113, 78, 0.2)" }}
    >
      <div className="flex flex-row justify-between items-start">
        <div className="flex flex-col gap-[10px]">
          <div className="flex items-center gap-2">
            <span className="font-mulish text-[#252525] text-base font-bold">
              {getOrdinal(index)} Attempt
            </span>
            {isBest && (
              <span className="inline-flex items-center gap-[3px] rounded-[5px] border border-[#EBEBEB] bg-white p-[5px]">
                <svg
                  width="9"
                  height="9"
                  viewBox="0 0 9 9"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.97654 3.25925C8.91763 3.07701 8.75598 2.94757 8.56475 2.93033L5.9671 2.69447L4.93992 0.290252C4.86418 0.114055 4.69169 0 4.50005 0C4.3084 0 4.13591 0.114055 4.06017 0.290664L3.03299 2.69447L0.434931 2.93033C0.244039 2.94798 0.0828104 3.07701 0.0235514 3.25925C-0.0357076 3.44149 0.0190194 3.64137 0.163425 3.76738L2.12694 5.48939L1.54794 8.03986C1.50558 8.22739 1.57836 8.42124 1.73396 8.53371C1.8176 8.59414 1.91545 8.6249 2.01412 8.6249C2.0992 8.6249 2.18359 8.60196 2.25933 8.55665L4.50005 7.21745L6.73994 8.55665C6.90385 8.65525 7.11047 8.64626 7.26572 8.53371C7.42139 8.42089 7.4941 8.22698 7.45174 8.03986L6.87274 5.48939L8.83626 3.76772C8.98066 3.64137 9.0358 3.44183 8.97654 3.25925Z"
                    fill="#FFC107"
                  />
                </svg>
                <span className="font-mulish font-semibold text-[8px] leading-none text-[#252525]">
                  Best attempt
                </span>
              </span>
            )}
          </div>
          <div className="font-mulish font-medium text-[12px] leading-none et-analytics-muted text-[#25252566]">
            {formatDate(attempt.startTime)}
          </div>
          {attempt.studentPerformance?.timeSpent != null &&
            attempt.studentPerformance.timeSpent > 0 && (
              <div className="font-mulish font-medium text-[12px] leading-none et-analytics-muted text-[#25252566]">
                Time: {formatTimeSpent(attempt.studentPerformance.timeSpent)}
              </div>
            )}
        </div>
        <div
          className={`w-[24px] h-[19px] rounded-[5px] ${backgroundColor} ${border}`}
        />
      </div>
      {transcriptionsEnabled && (
        <button
          type="button"
          aria-haspopup="dialog"
          className="et-support-link"
          onClick={handleViewTranscripts}
        >
          View Instances of Support
        </button>
      )}
    </div>
  );
};

export default BiteCard;
